import {BaseGraphNode} from "#graph/nodes/base/node"
import {z} from "zod"

export const isBaseGraphNodeInstance = (value: unknown): value is BaseGraphNode => {
    return value instanceof BaseGraphNode
}

export const nodeParameters = z.record(z.unknown())
